import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="container-site py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50">新金瓶梅</span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              经典名著的全新解读与深度赏析，汇聚学术研究、文化赏析与人物解析的权威平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200">首页</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200">关于我们</Link></li>
              <li><Link to="/category/xueshu-yanjiu" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200">学术研究</Link></li>
              <li><Link to="/category/shendu-jiedu" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200">深度解读</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-mail-line"></i></span>
                contact@xinjinpingmei.com
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-map-pin-line"></i></span>
                北京市海淀区中关村南大街5号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">&copy; {new Date().getFullYear()} 新金瓶梅. 保留所有权利.</p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-secondary-500">京ICP备2024XXXXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}